import React, { useState } from "react";
import { Box, Button, FormControl, Heading, Input, Text, VStack, useToast } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { VMS_COLORS } from "../constants/theme";
import { vmsApi } from "../services/vmsApi";

const VmsForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const submit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast({ title: "Email required", description: "Enter your email address.", status: "warning" });
      return;
    }
    setIsLoading(true);
    try {
      const res = await vmsApi.forgotPassword(email);
      toast({
        title: "Request submitted",
        description: res?.message || "If the email exists, a reset link has been sent.",
        status: "success",
      });
    } catch (err) {
      toast({ title: "Request failed", description: err?.message, status: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box minH="100vh" bg={VMS_COLORS.bg} display="grid" placeItems="center" p={4}>
      <Box bg="white" w="100%" maxW="460px" borderRadius="18px" border="1px solid" borderColor="gray.200" p={6}>
        <VStack as="form" align="stretch" spacing={4} onSubmit={submit}>
          <Heading size="md">Forgot Password</Heading>
          <Text fontSize="sm" color="gray.600">
            Enter your VMS account email and we will send a password reset link.
          </Text>
          <FormControl>
            <Input
              type="email"
              placeholder="office.user@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              bg="#F3F4F6"
              borderColor="transparent"
            />
          </FormControl>
          <Button type="submit" bg={VMS_COLORS.primary} color="white" isLoading={isLoading}>
            Send reset link
          </Button>
          <Button as={RouterLink} to="/vms/login" variant="ghost" size="sm">
            Back to login
          </Button>
        </VStack>
      </Box>
    </Box>
  );
};

export default VmsForgotPassword;
